import { commonTranslationES } from '@common/translations/es';

export const individualsES = {
  ...commonTranslationES,
  Individuals: 'Individuals',
  'Folder Name': 'Folder Name',
  'New Folder': 'New Folder',
  'Move':'Move',
  'Failed to move folder': 'Failed to move folder',
  'Specify name of new individual': 'Specify name of new individual',
  'Select where to move the folder to': 'Select where to move the folder to',
  'Move Folder':'Move Folder',
  'Rename Folder':'Rename Folder',
  'Open Individual Spreadsheet for Folder':'Open Individual Spreadsheet for Folder',
  'Delete Folder':'Delete Folder',
  'Read Folder': 'Read Folder',
  'Add Ped': 'Add Ped',
  'Del Ped': 'Del Ped',
  'Modify Ped': 'Modify Ped',
  'Ped Read': 'Ped Read',
  'Ped Write': 'Ped Write',
  'Failed to save Folder': 'Failed to save Folder',
  'Failed to get Folder Security Settings': 'Failed to get Folder Security Settings',
  'Only Probands': 'Only Probands',
  'Individual Datasheet': 'Individual Datasheet',
  'Pedigree Datasheet': 'Pedigree Datasheet',
  'Icon Subtext': 'Icon Subtext',
  'Icon Symbols': 'Icon Symbols',
  'Pedigree Added' : 'Pedigree Added' ,
  'SmartDraw Dimensions': 'SmartDraw Dimensions',
  'Pedigree Properties': 'Pedigree Properties',
  'Pedigree Fields' : 'Pedigree Fields' ,
  'Smart Header': 'Smart Header',
  'Smart Footer': 'Smart Footer',
  'Formats': 'Formats',
  'Template Options': 'Template Options',
  'Template Formats': 'Template Formats',
  'OK': 'OK',
  'Are you sure that you would like to delete the folder named': 'Are you sure that you would like to delete the folder named',
  'Deleting this folder will delete all of the pedigrees and individuals in this folder as well as any sub-folders and items they contain': 'Deleting this folder will delete all of the pedigrees and individuals in this folder as well as any sub-folders and items they contain',
  'Failed to get create formats folder': 'Failed to get create formats folder',
  'Failed to get delete formats folder': 'Failed to get delete formats folder',
  'Failed to get delete formats': 'Failed to get delete formats',
  'Failed to delete folder': 'Failed to delete folder',
  'Failed to rename folder': 'Failed to rename folder',
  'Edit Folder Settings': 'Edit Folder Settings',
  'Failed to get Format folders': 'Failed to get Format',
  'Failed to get Folder formats': 'Failed to get Folder formats',
  'Failed to get Folder Security Settings': 'Failed to get Folder Security Settings',
  'Override Pedigree Level Security': 'Override Pedigree Level Security',
  'Class Name': 'Class Name',
  'All Individuals': 'All Individuals',
  'Individual Name': 'Individual Name',
  'New Individual': 'New Individual',
  'Create': 'Create',
  'Save': 'Save',
  'Sex': 'Sex',
  'Male': 'Male',
  'Female': 'Female',
  'Unknown': 'Unknown',
  'Move to pedigree': 'Move to pedigree',
  'Existing Pedigree': 'Existing Pedigree',
  'Pedigree Name': 'Pedigree Name',
  'New Pedigree': 'New Pedigree',
  'Pedigree Folder': 'Pedigree Folder',
  'Failed to move individual': 'Failed to move individual',
  'Move Individuals to Pedigree': 'Move Individuals to Pedigree',
  'There no individuals to display': 'There no individuals to display',
  'Select an individual to view invites': 'Select an individual to view invites',
  'of items in': 'of items in',
  'items in': 'items in',
  Folder: 'Folder',
  'Pedigree Folders': 'Pedigree Folders',
  'There are no invites to display': 'There are no invites to display',
  'Operation canceled': 'Operation canceled',
  'Failed to get data': 'Failed to get data',
  'Failed to get individuals columns': 'Failed to get individuals columns',
  'Failed to get individuals': 'Failed to get individuals',
  'Failed to get invites': 'Failed to get invites',
  'Failed to get invites columns': 'Failed to get invites columns',
  'Failed to save resized columns': 'Failed to save resized columns',
  Ok: 'Ok',
  'Set as Default for All Users': 'Set as Default for All Users',
  'Set as Default for Specific Profiles': 'Set as Default for Specific Profiles',
  'Apply Current Columns Now to All Users': 'Apply Current Columns Now to All Users',
  'Apply Current Columns Now to Specific Profiles': 'Apply Current Columns Now to Specific Profiles',
  'Restore Columns to Default': 'Restore Columns to Default',
  'Select Profile': 'Select Profile',
  'Failed to select profile': 'Failed to select profile',
  'Failed to get profiles': 'Failed to get profiles',
  'Add Column': 'Add Column',
  'Delete Column': 'Delete Column',
  'Apply': 'Apply',
  'Rename Individual': 'Rename Individual',
  'Type new individual name': 'Type new individual name',
  Rename: 'Rename',
  'Failed to rename individual': 'Failed to rename individual',
  'Open Datasheet': 'Open Datasheet',
  'Open Pedigree': 'Open Pedigree',
  'Open Test Results': 'Open Test Results',
  'Generate Letter': 'Generate Letter',
  'Individual successfully renamed': 'Individual successfully renamed',
  'Information Message': 'Information Message',
  'Batch Letters': 'Batch Letters',
  'New Invite': 'New Invite',
  'Unlock Invite': 'Unlock Invite',
  'Lock Invite': 'Lock Invite',
  'View Invite History': 'View Invite History',
  'Select a Questionnaire you want to invite patients to': 'Select a Questionnaire you want to invite patients to',
  'Questionnaire Name': 'Questionnaire Name',
  'Datasheet Format Name': 'Datasheet Format Name',
  Previous: 'Previous',
  'Send an Invite': 'Send an Invite',
  Next: 'Next',
  'Edit content of your email': 'Edit content of your email',
  'Email Subject': 'Email Subject',
  "Insert {NAME} placeholder": "Insert {NAME} placeholder",
  "Insert hyperlink with {LINK} placeholder": "Insert hyperlink with {LINK} placeholder",
  "The Questionnaire invitation emails were successfully submitted": "The Questionnaire invitation emails were successfully submitted",
  'Launch Questionnaire': 'Launch Questionnaire',
  'Launch New Questionnaire': 'Launch New Questionnaire',
  'Open Questionnaire': 'Open Questionnaire',
  'Select a Questionnaire': 'Select a Questionnaire',
  'New Questionnaire for': 'New Questionnaire for',
  'Open Questionnaire for': 'Open Questionnaire for',
  'Status': 'Status',
  'Date Started': 'Date Started',
  'Date Completed': 'Date Completed',
  'Invited By': 'Invited By',
  'Operation failed': 'Operation failed',
  "Text": "Text",
  'Failed to save columns': 'Failed to save columns',
  'There is a problem with the email address for this individual, please enter a valid email address': 'There is a problem with the email address for this individual. Please enter a valid email address',
  "Selected questionnaire doesn't have Datasheet Format": "Selected questionnaire doesn't have Datasheet Format",
  "The individual you selected must be moved to a new pedigree in order to send a Family History Questionnaire.": "The individual you selected must be moved to a new pedigree in order to send a Family History Questionnaire.",
  "What is the name of the new pedigree?": "What is the name of the new pedigree?",
  "Select a folder": "Select a folder",
  "The Pedigree Name you entered is already used in this database, please choose another name": "The Pedigree Name you entered is already used in this database, please choose another name",
  "Failed to create pedigree": "Failed to create pedigree",
  "Failed to get family members data": "Failed to get family members data",
  "Failed to get family data": "Failed to get family data",
  patient: 'patient',
  "Send Reminder": "Send Reminder",
  "Send a Reminder": "Send a Reminder",
  "Individual name already exists in this folder": "Individual name already exists in this folder",
  "The Questionnaire reminder email was successfully sent": "The Questionnaire reminder email was successfully sent",
  "New Invites": "New Invites",
  "Email appears to be invalid": "Email appears to be invalid",
  'The Questionnaire invitation emails were successfully submitted': 'The Questionnaire invitation emails were successfully submitted',
  'Update Status': 'Update Status',
  "'Reviewed' Status Actions": "'Reviewed' Status Actions",
  'Transmit Pedigree PDF to EMR': 'Transmit Pedigree PDF to EMR',
  'Move To Folder': 'Move To Folder',
  'Send Email': 'Send Email',
  'Who to Email': 'Who to Email',
  "Changing the status to 'Reviewed' will trigger the following actions:": "Changing the status to 'Reviewed' will trigger the following actions:",
  'Select a Folder': 'Select a Folder',
  'Failed to update status': 'Failed to update status',
  'Failed to get email templates': 'Failed to get email templates',
  'Failed to get folders': 'Failed to get folders',
  'Failed to get status data': 'Failed to get status data',
  'Completed Manually': 'Completed Manually',
  'Inactive': 'Inactive',
  Reviewed: 'Reviewed',
  "There is a problem with the email addresses for the selected individuals": "There is a problem with the email addresses for the selected individuals",
  "Invitations were not sent to the following individuals:": "Invitations were not sent to the following individuals:",
  "Please enter valid email addresses and resend the invitations": "Please enter valid email addresses and resend the invitations",
  'Change Sex': 'Change Sex',
  'Delete Individual': 'Delete Individual',
  'Edit Individual Security': 'Edit Individual Security',
  'Confirmation Message': 'Confirmation Message',
  'After locking this invite the patient will not be able to edit the questionnaire': 'After locking this invite the patient will not be able to edit the questionnaire',
  'Are you sure you want to lock this invite? You can unlock it again later if needed': 'Are you sure you want to lock this invite? You can unlock it again later if needed',
  'If you unlock this invite the patient will be able to access the questionnaire and modify data': 'If you unlock this invite the patient will be able to access the questionnaire and modify data',
  'Are you sure you want to unlock?': 'Are you sure you want to unlock?',
  'Failed to save lock/unlock invite': 'Failed to save lock/unlock invite',
  'Are you sure you wish to delete the selected Individual?': 'Are you sure you wish to delete the selected Individual?',
  'Failed to delete individual': 'Failed to delete individual',
  'Yes': 'Yes',
  'No': 'No',
  'Failed to change sex': 'Failed to change sex',
  'Individual sex successfully changed to': 'Individual sex successfully changed to',
  'Edit Pedigree Security': 'Edit Pedigree Security',
  'Class Name': 'Class Name',
  'Read?': 'Read?',
  'Write?': 'Write?',
  'Security for this pedigree is overridden at the folder level': 'Security for this pedigree is overridden at the folder level',
  'Failed to get security information': 'Failed to get security information',
  'Failed to load pedigrees': 'Failed to load pedigrees',
  'Search for Pedigree': 'Search for Pedigree',
  'Pedigree Chooser': 'Pedigree Chooser',
  'to': 'to',
  'View Invite History for': 'View Invite History for',
  'Date': 'Date',
  'There no invite histories to display': 'There no invite histories to display',
  'Security settings were successfully changed': 'Security settings were successfully changed',
  'Failed to get generated external link': 'Failed to get generated external link',
  'Press Ctrl+C to copy URL to clipboard': 'Press Ctrl+C to copy URL to clipboard',
  'External URL': 'External URL',
  'Failed to get profile': 'Failed to get profile',
  'Individuals moved successfully': 'Individuals moved successfully',
  'Failed to load invite history': 'Failed to load invite history',
  'Transmit Events': 'Transmit Events',
  'Failed to transmit event': 'Failed to transmit event',
  'Transmit Events saved successfully': 'Transmit Events saved successfully',
  'Choose file': 'Choose file',
  'Failed to open questionnaire': 'Failed to open questionnaire',
  'inviteIsLockedToSendReminder': 'This invite is locked, unable to send reminder. Please unlock before attempting to send another reminder.',
  'individualMovePedigreeMsg': 'The individual you selected must be moved to a new pedigree in order to send a Family History Questionnaire.',
  'FHQ Version': 'FHQ Version',
};